"use strict";

import { AppDispatcher } from 'Dispatcher';
import { D5TableConstants } from "Constants/Table/D5TableConstants";
export function d5TableFilterSaved(_ref) {
  var formUUID = _ref.formUUID,
      sender = _ref.sender,
      table = _ref.table,
      formEditUUID = _ref.formEditUUID;
  AppDispatcher.asyncDispatch({
    actionType: D5TableConstants.D5_TABLE_FILTER_SAVED,
    formUUID: formUUID,
    sender: sender,
    formEditUUID: formEditUUID,
    table: table
  });
}
export function d5TableRefresh(formUUID) {
  AppDispatcher.dispatch({
    actionType: D5TableConstants.D5_TABLE_FORM_REFRESH,
    formUUID: formUUID
  });
}
export function d5TableFocusRowAfterFormEdit(options) {
  AppDispatcher.asyncDispatch({
    actionType: D5TableConstants.D5_TABLE_FOCUS_LAST_ROW,
    options: options
  });
}
export function d5TableFocusRowAfterFullEdit(rowID) {
  AppDispatcher.asyncDispatch({
    actionType: D5TableConstants.D5_TABLE_FOCUS_LAST_ROW_FULL,
    rowID: rowID
  });
}
export function d5TableUpdateFormUUID(formUUID, nextFormUUID) {
  AppDispatcher.dispatch({
    actionType: D5TableConstants.D5_TABLE_UPDATE_FORM_UUID,
    formUUID: formUUID,
    nextFormUUID: nextFormUUID
  });
}
export function d5TableUserEvent(options) {
  AppDispatcher.asyncDispatch({
    actionType: D5TableConstants.D5_TABLE_USER_EVENT,
    options: options
  });
}
export function d5TableOnMasterChanged(options) {
  AppDispatcher.asyncDispatch({
    actionType: D5TableConstants.D5_TABLE_ON_MASTER_CHANGED,
    options: options
  });
}
export function d5TableUpdateFilterSubForm(formUUID, fieldsData) {
  AppDispatcher.asyncDispatch({
    actionType: D5TableConstants.D5_TABLE_UPDATE_FILTER_SUBFORM,
    formUUID: formUUID,
    fieldsData: fieldsData
  });
}
export function d5SendNestedDataToForm(options) {
  AppDispatcher.asyncDispatch({
    actionType: D5TableConstants.D5_SEND_NESTED_DATA,
    options: options
  });
}
export function d5TableExport(formUUID, exportSelected) {
  AppDispatcher.asyncDispatch({
    actionType: D5TableConstants.D5_TABLE_EXPORT,
    formUUID: formUUID,
    exportSelected: exportSelected
  });
}
export function updateLayoutFilters(formUUID, sender) {
  AppDispatcher.asyncDispatch({
    actionType: D5TableConstants.D5_UPDATE_LAYOUT_FILTER,
    formUUID: formUUID,
    sender: sender
  });
}
export function d5TableResetScroll(formUUID) {
  AppDispatcher.dispatch({
    actionType: D5TableConstants.D5_TABLE_RESET_SCROLL,
    formUUID: formUUID
  });
}